<template>
  <div class="bg-white rounded p-3" style="height: 30em">
    <h3 class="font-weight-bolder">Products Market Share</h3>
    <pie-chart :chartData="pieChartData" style="position: relative; height:32vh; width:25vw" />
    <hr />
    <div class="float-right float-xl-left">
      <div v-for="(product, index) in products" :key="product.Product_code || index">
        <p class="mt--3">
          <i class="fa fa-square" aria-hidden="true" v-bind:style="{ color: product.color }"></i>
          {{ product.Product_name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from "../../components/Charts/PieChart.js";
import { getReportingProducts } from "../../helpers/reportingProducts";

export default {
  name: "product-pie-chart",
  props: {
    dataChart: {
      type: Array,
      required: true
    },
    reportingProducts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pieChartData: {}
    };
  },
  computed: {
    products() {
      return this.reportingProducts.length
        ? this.reportingProducts
        : getReportingProducts();
    }
  },
  watch: {
    dataChart() {
      this.initChart()
    },
    reportingProducts: {
      deep: true,
      handler() {
        this.initChart()
      }
    }
  },
  methods: {
    async initChart() {
      const counts = this.products.map(
        (product) =>
          _.filter(this.dataChart, (item) => item.product === product.Product_code).length
      );
      this.pieChartData = {
        datasets: [
          {
            backgroundColor: this.products.map((p) => p.color),
            hoverOffset: 4,
            data: counts
          }
        ],
        labels: this.products.map((p) => p.Product_name)
      };
    }
  },
  components: {
    PieChart
  }
};
</script>

<style scoped></style>
